module.exports = __webpack_public_path__ + "static/img/sanzhangpuke.665493e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/sanzhangpuke.jpg
// module id = nB2o
// module chunks = 0